export default __webpack_public_path__ + "static/media/bootstrap_ui.f3e679f6.PNG";